import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('AccordionTitle')(css({
    color: 'inherit',
    fontFamily: 'bold',
    py: 'm',
}));
themeStyles.addBaseStyles('AccordionWrapper')(css({
    px: ['s', 's', '40px'],
}));
export default themeStyles;
